const SAFE_REDIRECT_PATH = /^[a-zA-Z0-9/_-]+$/;

export const CSA_SIGNUP_REDIRECT = "csa-signup";

export function sanitizeAuthRedirect(
  redirect: string | null | undefined,
): string | null {
  if (!redirect?.trim()) return null;
  const path = decodeURIComponent(redirect).trim().replace(/^\/+/, "");
  if (!path || path.includes("..") || !SAFE_REDIRECT_PATH.test(path)) {
    return null;
  }
  return path;
}

export function loginPathWithRedirect(
  redirect: string | null | undefined,
): string {
  const safe = sanitizeAuthRedirect(redirect);
  return safe ? `/login?redirect=${encodeURIComponent(safe)}` : "/login";
}

export function signupPathWithRedirect(
  redirect: string | null | undefined,
): string {
  const safe = sanitizeAuthRedirect(redirect);
  return safe ? `/signup?redirect=${encodeURIComponent(safe)}` : "/signup";
}
